"use client";

import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";

interface ReactSwaggerProps {
  url: string;
}

/**
 * Client-side Swagger UI component for rendering interactive API documentation.
 * Loads the spec from the given URL rather than receiving an inline spec — the
 * spec is pre-generated at build time and served from /api-docs/swagger.json.
 */
export default function ReactSwagger({ url }: ReactSwaggerProps) {
  return <SwaggerUI url={url} />;
}
